import {FilterByGamesComponent} from './index';
import {FilterByGamesComponent as MobileFilterByGamesComponent} from './mobile';
import UserAgent from 'helpers/device';

const Factory = {
    getComponent(sportConfig) {
        return UserAgent.isMobile() ? MobileFilterByGamesComponent : FilterByGamesComponent;
    },
};

export {Factory};
